function animate(callback, { duration, easing }) {
  const ease = (t) => {
      const [p0, p1, p2, p3] = easing;
      const c = (1 - t) * (1 - t) * (1 - t);
      const b = 3 * (1 - t) * (1 - t) * t * p1;
      const d = 3 * (1 - t) * t * t * p2;
      const e = t * t * t;
      return c + b + d + e;
  };

  const start = performance.now();
  function frame(time) {
      const progress = Math.min((time - start) / duration, 1);
      callback(ease(progress));

      if (progress < 1) {
          requestAnimationFrame(frame);
      }
  }

  requestAnimationFrame(frame);
}


function inView(element, callback) {
  const checkInView = () => {
      const rect = element.getBoundingClientRect();
      if (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      ) {
          callback();
          window.removeEventListener("scroll", checkInView);
      }
  };

  window.addEventListener("scroll", checkInView);
  checkInView();
}

(function () { 
  class ImageComparison extends HTMLElement {
    constructor() {
        super();
        this._onPointerMoveListener = this._onPointerMove.bind(this);
        this._touchStartTimestamp = 0;

        this.addEventListener("pointerdown", this._onPointerDown.bind(this));
        this.addEventListener("keydown", this._onKeyboardNavigation.bind(this));
        this.addEventListener("touchstart", this._onTouchStart.bind(this), { passive: false });
    }

    connectedCallback() {
        //inView(this, this._animateInitialPosition.bind(this));
      this._animateInitialPosition();
    }

    _onPointerDown(event) {
        if (event.target.tagName === "A") {
            return;
        }

        document.addEventListener("pointerup", this._onPointerUp.bind(this), { once: true });
        if (this._supportsHover()) {
            document.addEventListener("pointermove", this._onPointerMoveListener);
            this._calculatePosition(event);
        }
    }

    _onPointerMove(event) {
        this._calculatePosition(event);
    }

    _onTouchStart(event) {
        const cursor = this.querySelector(".image-comparison__cursor");
        if (event.target === cursor || cursor.contains(event.target)) {
            event.preventDefault();
            document.addEventListener("pointermove", this._onPointerMoveListener);
        } else {
            this._touchStartTimestamp = event.timeStamp;
        }
    }

    _onPointerUp(event) {
        document.removeEventListener("pointermove", this._onPointerMoveListener);
        if (!this._supportsHover() && event.timeStamp - this._touchStartTimestamp <= 250) {
            this._calculatePosition(event);
        }
    }

    _onKeyboardNavigation(event) {
        if (
            !event.target.classList.contains("image-comparison__cursor") ||
            (!this.hasAttribute("vertical") && event.code !== "ArrowLeft" && event.code !== "ArrowRight")
        ) {
            return;
        }

        event.preventDefault();
        let currentPosition = parseInt(this.style.getPropertyValue("--image-comparison-cursor-position"));
        if (Number.isNaN(currentPosition)) {
            currentPosition = parseInt(getComputedStyle(this).getPropertyValue("--image-comparison-initial-cursor-position"));
        }

        let newPosition = event.code === "ArrowLeft" ? currentPosition - 1 : currentPosition + 1;
        this.style.setProperty("--image-comparison-cursor-position", `${Math.min(Math.max(newPosition, 0), 100)}%`);
    }

    _calculatePosition(event) {
        const rect = this.getBoundingClientRect();
        let percentage;
        percentage = ((event.clientX - rect.left) / this.clientWidth) * 100;
        percentage = document.dir === "rtl" ? 100 - percentage : percentage;
        this.style.setProperty("--image-comparison-cursor-position", `${Math.min(Math.max(percentage, 0), 100)}%`);
    }

    _animateInitialPosition() {
        animate((progress) => {
            this.style.setProperty(
                "--image-comparison-cursor-position",
                `calc(var(--image-comparison-initial-cursor-position) * ${progress})`
            );
        }, { duration: 0.6, easing: [0.85, 0, 0.15, 1] });
    }

    _supportsHover() {
        return window.matchMedia("(hover: hover)").matches;
    }
  }
  
  if (!window.customElements.get("image-comparison")) {
      window.customElements.define("image-comparison", ImageComparison);
  }
})();
